import * as z from "zod";
import { ensureWritable, modifyStepConfig } from "../copyOnWrite";
import { mutator } from "./mutator";
import { branchSchema, insertUserAction } from "./utils";

export const updateStepColor = mutator({
  schema: z
    .object({
      stepDir: z.string(),
      color: z.string(),
    })
    .merge(branchSchema),
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args }) => {
    const {
      stepDir,
      color,
      branch,
      forkBranchId,
      forkCommitId,
      forkChatId,
      workingCommitId,
      workingChatId,
    } = args;
    const { commitId } = await ensureWritable(
      tx,
      ctx,
      ctx.tenantId,
      {
        branchId: branch.id,
        forkBranchId,
        forkCommitId,
        forkChatId,
        workingCommitId,
        workingChatId,
      },
      branch
    );
    await modifyStepConfig(tx, commitId, ctx.tenantId, stepDir, { color });
    await insertUserAction(tx, commitId, ctx, ctx.tenantId, "updateStepColor", {
      stepDir,
      color,
    });
  },
});
